/* eslint-disable max-len */
import { FC } from 'react';
import { AllieIconProps } from '../../../components';

export const RotationClockIcon: FC<AllieIconProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 118 118"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M81.1245 36.875L58.9995 59M108.167 59C108.167 86.154 86.1539 108.167 58.9999 108.167C31.8459 108.167 9.83325 86.154 9.83325 59C9.83325 31.846 31.8459 9.83331 58.9999 9.83331C86.1539 9.83331 108.167 31.846 108.167 59ZM63.9166 59C63.9166 61.7154 61.7153 63.9166 58.9999 63.9166C56.2845 63.9166 54.0833 61.7154 54.0833 59C54.0833 56.2846 56.2845 54.0833 58.9999 54.0833C61.7153 54.0833 63.9166 56.2846 63.9166 59Z"
      stroke="white"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
